/* globals Class, jui */

var jQuery = require('jquery');
var _ = require('lodash');

module.exports = Class.create(jui.ModalPanel, {

  /**
   *
   * Public
   *
   **/

  KEYCODES : {
    enter:  13,
    esc  :  27
  },

  options: function($super, options0) {
    var options = {
      attributes:{
        id:'dynamic-text-overlays',
        className: 'modal-panel dynamic-text-modal-panel'
      }
    };
    return $super(_.merge({}, options0, options));
  },

  initialize: function($super, options){
    options.showUpsell = window.gon ? !window.gon.dynamic_text : false;

    $super(options);

    if ( ! options.showUpsell) {
      this._clearErrors();
      this._addEvents();
    }
  },

  installUI: function($super) {
    $super();

    this.header           = this._header(this.options.showUpsell);
    this.closeButton      = this._closeButton();

    this.formContainer    = this._formContainer();

    if (this.options.showUpsell) {
      this.dialogFeatureInfo = this._upsellContent();
    } else {
      this.parameter         = this._parameter();
      this.textDefaultText   = this._textDefaultText();

      this.textTransform     = this._textTransform();

      this.dialogFeatureInfo = this._dialogFeatureInfo();

      this.errorMsg          = {
        textDefaultText: new jui.FieldErrorMessage({field: this.textDefaultText}),
        parameter: new jui.FieldErrorMessage({field: this.parameter})
      };

      this._hideFormErrors();
    }

    this.footer       = this._footer();
    this.cancelButton = this._cancelButton();

    if (this.options.showUpsell) {
      this.okButton = this._upgradeButton();
    } else {
      this.okButton = this._okButton();
    }

  },

  insertDynamicText: function() {
    if (this._formIsValid()) {
      this._insertDynamicTextElement();
    } else {
      this._showFormErrors();
    }
  },

  open: function($super, defaultText, attributes, callback) {
    if ( ! this.options.showUpsell) {
      this._hideFormErrors();
      this.insertDynamicTextCallback = callback;
      this._syncControls(defaultText, attributes);
      this.parameter.focusAndSelect();
    }
    $super();
  },

  close: function($super) {
    delete this.textSelection;
    $super();
    if ( ! this.options.showUpsell) {
      this._hideFormErrors();
    }
    jQuery('#text-transform-type').html('&nbsp;');
    if (this.options.onClose) { this.options.onClose(); }
    this.fireEvent('onDynamicTextDialogWindowClose', this);
  },

  /**
   *
   * Private
   *
   **/

  _addEvents: function() {
    var self = this;
    this.e.observe('keydown', function(e){
      if(e.keyCode === self.KEYCODES.esc) {
        self.close();
      } else if(e.keyCode === self.KEYCODES.enter) {
        e.stop();
        self.insertDynamicText();
      }
    }, this);
  },

  _clearErrors: function() {
    this.errors = [];
    this.textDefaultText.e.removeClassName('error');
    this.parameter.e.removeClassName('error');
    this.errorMsg.parameter.hide();
    this.errorMsg.textDefaultText.hide();
  },

  _header: function(showUpsell) {
    var headerTitle = showUpsell ? 'Upgrade for Dynamic Text Replacement' : 'Dynamic Text Replacement';
    var header = jQuery('<div class="modal-title-bar title-bar"><h1 class="modal-title-bar-title">' + headerTitle + '</h1></div>');

    return this.content.insert(header[0]);
  },

  _formContainer: function() {
    return this.content.insert(new jui.Component({
      attributes: { className: 'dynamic-text-modal-content-panel content-panel modal-content-panel' }
    }));
  },

  _dialogFeatureInfo: function() {
    var dialogFeatureInfo = jQuery('<div class="dynamic-text-info">' +
                                   '<span class="svg-ico-education info-icon"></span>' +
                                   '<p>Increase the quality score, ad rank and message match ' +
                                   'of your paid advertising by passing in text dynamically using URL parameters. ' +
                                   '<a href="http://documentation.unbounce.com/hc/en-us/articles/203661004-Dynamic-Text-Replacement-pro-"' +
                                   ' target="_blank">Learn more about dynamic text replacement »</a></p></div>');

    return this.formContainer.insert(dialogFeatureInfo[0]);
  },

  _upsellContent: function() {
    var dialogFeatureInfo = this.formContainer.insert(new jui.Component({
      attributes:            { className: 'dialog-feature-upsell' }
    })),
        heading = new Element('h2')
          .update("Dynamically replacing text on your pages will help you increase the quality score, ad rank and message match of your paid advertising by passing in text using URL parameters.");

    var videoIframe = new Element('iframe', {
      frameborder:           0,
      width:                 450,
      height:                253,
      allowtransparency:     true,
      scrolling:             'no',
      class:                 'wistia_embed',
      name:                  'wistia_embed',
      allowfullscreen:       'allowfullscreen',
      mozallowfullscreen:    'mozallowfullscreen',
      webkitallowfullscreen: 'webkitallowfullscreen',
      oallowfullscreen:      'webkitallowfullscreen',
      msallowfullscreen:     'webkitallowfullscreen',
      src:                   '//fast.wistia.net/embed/iframe/75urte6v0j?videoFoam=true'
    });

    var videoScript = new Element('script', {
      src: '//fast.wistia.net/assets/external/iframe-api-v1.js'
    });

    var details = new Element('p', {
      className: 'upsell-details'
    }).update("Dynamic Text Replacement is available on all Pro plans.");

    dialogFeatureInfo.insert(heading);
    dialogFeatureInfo.insert(videoIframe);
    dialogFeatureInfo.insert(videoScript);
    dialogFeatureInfo.insert(details);
    return dialogFeatureInfo;

  },

  _textDefaultText: function() {
    return this.formContainer.insert(new jui.FormTextInputWithHint({
      label       : 'Default Text',
      tabindex  : 2,
      attributes  : {
        className : 'default-text text-input-with-hint-container dtr-option',
        id        : 'jui-dynamic-default-text'
      },
      hintText    : 'Default text will be applied when there is no URL parameter defined',
    }));

  },

  _parameter: function() {
    return this.formContainer.insert(new jui.FormTextInput({
      label      : 'URL Parameter',
      tabindex  : 1,
      attributes : {
        id : 'jui-parameter-name',
        className: 'text-input-container dtr-option'
      }
    }));
  },

  _selectOptions : [
    {name : 'Select Text Style', value   : ''},
    {name : 'UPPERCASE',         value   : 'uppercase'},
    {name : 'lowercase',         value   : 'lowercase'},
    {name : 'Title Case',        value   : 'titlecase'},
    {name : 'Sentence case',     value   : 'capitalized'}
  ],

  _textTransform: function() {
    return this.formContainer.insert(new jui.FormSelectWithHint({
      label         : 'Select Text Style',
      tabindex      : 3,
      attributes    : {
        className   : 'text-transform jui-form-select dtr-option',
      },
      id            : 'jui-dynamic-text-transform',
      dropDownClassName: 'modal-select2-dropdown',
      width         : '100%',
      selectOptions : this._selectOptions,
      hintText      : '<span id="text-transform-type">&nbsp;</span>',
      action        : this._updateTypeHint.bind(this)
    }));
  },

  _updateTypeHint: function(e){
    var exampleText,
        message;

    switch(e.data) {
      case 'uppercase':
        exampleText = 'YOUR TEXT';
        break;
      case 'titlecase':
        exampleText = 'Your Text';
        break;
      case 'capitalized':
        exampleText = 'Your text';
        break;
      case 'lowercase':
        exampleText = 'your text';
        break;
      default:
        exampleText = '';
    }
    if (exampleText.length > 0) {
      message = 'Example: ' + exampleText;
    } else {
      message = '&nbsp;';
    }

    this.textTransform.hint.update(message);
  },

  _footer: function() {
    return this.content.insert(new jui.Component({
      attributes: {
        className: 'action-bar modal-action-panel'
      }
    }));
  },

  _upgradeButton: function() {
    return this.footer.insert(new jui.Button({
      label: 'Upgrade to use Dynamic Text Replacement',
      attributes: {
        className: 'button modal-button action',
        target:    '_blank'
      },
      action: function() {
        window.open('/change_subscription', '_blank');
        if (window.ga && window.ga !== undefined) {
          window.ga('send', 'event', 'button', 'click', 'DTR Upgrade From Builder');
        }
      }
    }));
  },

  _okButton: function() {
    return this.footer.insert(new jui.Button({
      label  : 'Save Dynamic Text',
      attributes: {
        tabindex: 5,
        className: 'button modal-button action'
      },
      action : this.insertDynamicText.bind(this)
    }));
  },

  _cancelButton: function() {
    return this.footer.insert(new jui.Button({
      label  : 'Cancel',
      attributes: {
        tabindex: 4,
        className: 'button modal-button push-left'
      },
      action : this.close.bind(this)
    }));
  },

  _closeButton: function() {
    var close = jQuery('<div class="modal-close-button"></div>')
          .on('click', this.close.bind(this));
    return this.header.insert(close[0]);
  },

  _syncControls: function(defaultText, attributes) {
    this.textTransform.select.setValue(attributes.method || '');

    this._updateTypeHint({data: attributes.method});

    this.parameter.setValue(attributes.parameter || '');
    this.textDefaultText.setValue(defaultText.trim() || '');
  },

  _showFormErrors: function() {
    this.errors.each(function(error) {
      this[error.field].e.addClassName('error');
      this.errorMsg[error.field].show(error.message);
    }, this);
  },

  _hideFormErrors: function() {
    this._clearErrors();
  },

  _getFormFieldValue: function(selector) {
    return jQuery(selector).val().trim();
  },

  _matchesRegex: function(field, regex) {
    return this._getFormFieldValue(field).match(regex);
  },

  _isBadParameterName: function(){
    var goodNamePattern = /^([a-zA-Z0-9_-]+)$/,
        isBad               = false,
        fieldName           = '#' + this.parameter.options.attributes.id + ' input';

    if ( ! this._matchesRegex(fieldName, goodNamePattern)) { isBad = true; }
    return isBad;
  },

  _isBadDefaultText: function() {
    return this.textDefaultText.getValue().trim().length === 0;
  },

  _formIsValid: function() {
    this._clearErrors();
    var isValid = true;
    this.errors = [];

    if (this._isBadParameterName()) {
      isValid          = false;
      var errorMessage = 'URL Parameter should only have letters, numbers, underscores and dashes.';

      this.errors.push({
        field: 'parameter',
        message: errorMessage
      });
    }

    if(this._isBadDefaultText()) {
      isValid = false;
      this.errors.push({
        field: 'textDefaultText',
        message: 'Default text is required.'
      });
    }
    return isValid;
  },

  _getDefaultText: function() {
    return this.textDefaultText.getValue();
  },

  _getAttributes: function() {
    return {
      method: this.textTransform.getValue(),
      parameter: jQuery.trim(this.parameter.getValue())
    };
  },

  _insertDynamicTextElement: function() {
    this.insertDynamicTextCallback(
      this._getDefaultText().trim(),
      this._getAttributes()
    );
    this.close();
  },

  });



// WEBPACK FOOTER //
// ./src/ui/dynamic_text_modal.js